import { Routes } from '@angular/router';
import { authGuard, isLoggedGuard } from './core/guards/auth.guard';
import { PermissionGuard } from './core/guards/permission.guard';
import { LayoutComponent } from './modules/layout/layout.component';

export const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    loadChildren: () => import('./modules/layout/layout-app-routes').then((m) => m.LAYOUT_APP_ROUTES),
    canActivate: [authGuard, PermissionGuard],
  },
  {
    path: 'auth',
    loadComponent: () => import('./modules/auth/signin/signin.component').then((m) => m.SigninComponent),
    canActivate: [isLoggedGuard],
  },
  {
    path: 'set-password',
    loadComponent: () => import('./modules/auth/set-password/set-password.component').then((m) => m.SetPasswordComponent),
  },
  {
    path: 'forgot-password',
    loadComponent: () => import('./modules/auth/forgot-password/forgot-password.component').then((m) => m.ForgotPasswordComponent),
  },
  {
    path: 'reset-password',
    loadComponent: () => import('./modules/auth/set-password/set-password.component').then((m) => m.SetPasswordComponent),
  },
  {
    path: 'interview',
    loadChildren: () => import('./modules/staffing/promotions/interview-forms/interview-forms-routes').then((m) => m.INTERVIEW_FORMS_ROUTES),
    canActivate: [authGuard, PermissionGuard],
  },
  {
    path: 'demo-permissions',
    loadComponent: () => import('./shared/components/permission-demo/permission-demo.component').then((m) => m.PermissionDemoComponent),
    canActivate: [authGuard],
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full',
  },
];
